import { CountryConfig, Configurable } from '@crystal/config'

import { MfSiteConfig } from '../types'

const mfSiteConfig = Configurable.props<Partial<MfSiteConfig>>({
  legalPolicy: {
    minAgeRequired: true,
  },
})

export const PH: CountryConfig<Partial<MfSiteConfig>> = {
  PH: mfSiteConfig,
}
